export const TOGGLE_NAVIGATION = 'TOGGLE_NAVIGATION';

export const toggleNavigation = (force?: boolean) => ({ type: TOGGLE_NAVIGATION, payload: force });
